
































import Vue, { PropType } from 'vue';

import { ProfileInfo } from 'spa_registration_app/store/modules/register';
import CvPreview from '../../components/cv-preview.vue';

export default Vue.extend({
  components: { CvPreview },
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    },
    profileInfo: {
      type: Object as PropType<ProfileInfo>,
      required: true,
    },
    pErrors: {
      type: Array as PropType<string[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onSubmit() {
      const cvPreview = this.$refs.CvPreview as InstanceType<typeof CvPreview>;
      this.$emit('submit', cvPreview.generateSubmitValue());
    },
  },
});
